module.exports = __webpack_public_path__ + "media/images/emoticons/four-a6faa0dcec27385eb893cd6d3312e46f.gif";